module.exports = __webpack_public_path__ + "static/media/fintechtimes.ecd4c0eb.jpeg";